<template>
	<div id="real-name" class="form-container">
		<h2>{{$t('question.SecurityQuestion')}}</h2>
		<div class="form-item">
			<label for="">{{$t("question.SecurityQuestion")}}</label>
			<select name="" id="" v-model="question_id">
				<option 
					:selected="question_id == q.id"				
					:value="q.id" 
					v-for="(q,idx) in activeQuestion" 
					:key="'q-opt-'+idx">{{q.question}}</option>
			</select>
		</div>
		<div class="form-item">
			<label for="">{{$t("question.SecurityAnswer")}}</label>
			<input type="text" v-model="answer" @focus="validated = false" :class="(validated && !answer) ? 'error' : ''" :placeholder="$t('question.SecurityAnswerTip')">
		</div>
		<div class="form-item">
			<label for="">{{$t("question.ConfirmAnswer")}}</label>
			<input type="text" v-model="confirmAnswer" @focus="validated = false" :class="(validated && !confirmAnswer) ? 'error' : ''" :placeholder="$t('question.ConfirmAnswerTip')">
		</div>
		<div class="form-item code-item">
			<label for="">{{$t("default.VerificationCode")}}</label>
			<input type="text" 
				@focus="validated = false"
				class="code-input" 
				maxlength="4" 
				v-model="verificationCode" 
				:placeholder="$t('default.VerificationCodeTip')" 
				:class="(validated && !verificationCode) ? 'error' : ''">
			<v-code ref="vcode"></v-code>
		</div>
		<div class="form-item">
			<label for=""></label>
			<wd-button type="danger" @click.native="submit" size="large" :styles="{width:'300px'}">{{$t("default.submit")}}</wd-button>
		</div>
	</div>
</template>
<script>
	import WdButton from '@/components/WdButton.vue';
	import VerificationCode from '@/components/VerificationCode.vue';
	export default{
		name:"question",
		data(){
			return {
				question_id:0,
				answer:"",
				confirmAnswer:"",
				verificationCode:"",
				validated:false,
				questions:[],
			}
		},
		components:{
			'wd-button':WdButton,
			'v-code':VerificationCode
		},
		computed:{
			activeQuestion(){
				return this.arrFilter();
			}
		},

		methods:{
			arrFilter(){
				var arr=[];
				var lang = this.$i18n.locale;
				this.questions.forEach(function(item){
					if(item.language == lang){
						arr.push(item)
					}
				})
				if(arr.length>0) this.question_id  = arr[0].id;
				return arr;
			},
			async submit(){
				this.validated = true;
				if(!this.answer){
					this.$alert(this.$t("question.SecurityAnswerTip"))
					return;
				}
				if(this.$i18n.locale == 'zh' && this.answer.length>20){
					this.$alert(this.$t("question.AnswerLength"))
					return;
				}
				if(this.$i18n.locale !== 'zh' && this.answer.length>40){
					this.$alert(this.$t("question.AnswerLength"))
					return;
				}
				
				if(!this.verificationCode){
					this.$alert(this.$t("default.VerificationCodeTip"))
					return;
				}
				if(this.answer != this.confirmAnswer){
					this.$alert(this.$t('question.QuestionNotMatch'))
					return;
				}
				let q = "";
				for (var i = this.questions.length - 1; i >= 0; i--) {
					if(this.questions[i].id == this.question_id){
						q = this.questions[i].question;
						break;
					}
				}
				let postData = {
					answer:this.answer,
					confirm_answer:this.confirmAnswer,
					code:this.verificationCode,
					question:q
				}
				let response = await this.$api.post('/web/index/setSecurityQuestion',postData);
				if(response.code == 0){
					this.$setUser({security_question:q});
					this.$result(this.$t('question.SetQuestionSuccess'));
					this.validated = false;
					this.answer = "";
					this.confirmAnswer = "";
					this.verificationCode = "";
					this.$refs.vcode.refreshSrc();
				}else{
					if(response.code == 10004){
						this.$alert(this.$t('default.ImgCodeErr'));
					}else{
						this.$alert(response.msg);
					}
				}

			},
			async getQuestions(){
				let response = await this.$api.get('/web/basic/getSecurityQuestions');
				if(response.code == 0){
					this.questions = this.questions.concat(response.data);

					// this.question_id = this.questions[0].id;
				}
			},
		},
		async created(){
			// let user = await this.$getUser();
			// if(user && user.security_question){
			// 	this.questions.push({id:0,question:user.security_question,language:this.$i18n.locale});
			// }
			this.getQuestions();
			
		}

		
	}
</script>
<style scoped>
	.form-container{
		margin-top: 50px;
	}
</style>
